<template>
  <div>
    <elsa-v-upload v-model="file" file-type="xlsx" />
    <div :class="$style.footer">
      <vs-button button="submit" type="border" color="success" @click="onSubmitForm">Загрузить</vs-button>
    </div>
  </div>
</template>

<script>
import modalContext    from "@/mixins/modalContext";
import notifyHttpError from "@/mixins/notifyHttpError";

export default {
  name:    "gisTariffUploadPopup",
  mixins:  [modalContext, notifyHttpError],
  props:   ['buildingId', 'onSubmit'],
  data() {
    return {
      file: null,
    };
  },
  methods: {
    onSubmitForm() {
      if (this.isProgress) return;

      if (!this.file) return;

      this.isProgress = true;
      this.onSubmit(this.file).then(
        () => this.modalResolve(),
        this.notifyHttpError,
      ).finally(() => this.isProgress = false);
    },
  },
  mounted() {

  },
};
</script>

<style lang="scss" module>
.footer {
  text-align: center;
  margin-top: 1em;
}
</style>
